import restaurant from "./data/restaurant.json";

const initialState = {
    restaurant: restaurant,
    bookmark: {userId:"", restaurantId: 0, bookmark_state: false}
}
const restaurantData = (state = initialState, action) => {
    switch (action.type){
        case "get-restaurant":
            return ({
                restaurant: {...state.restaurant,...action.restaurant}

            });
        case "get-bookmarks":

            let bookmark = {};
            if(Array.isArray(action.bookmark)){
                bookmark = {...action.bookmark[0]};
            }
            else{
                bookmark = {...action.bookmark}
            }
            return (
            {...state,
                bookmark: {...state.bookmark, ...bookmark}
            });

        default:
            return({restaurant:state.restaurant});
    }
};

export default restaurantData;